import { getValue } from 'firebase-utils'
import {
    getOtherUseCaseTextValue,
    isMarketingUsecasePresent,
    isOnlyMarketingPresent,
    replacePlaceholderWithActualBrandValues,
    useCasesOptions
} from './util'

const campaign2ndStepRemoteValues = JSON.parse(getValue('sms_enrollment_campaigns_2nd_step'))

const generateCampaignDescription = (useCases, brand) => {
    const other = getOtherUseCaseTextValue(useCases)
    if (useCases.length === 1 && useCases[0]) {
        const uc = useCasesOptions.find((x) => x.id === useCases[0])
        if (uc && uc.campaignDescription) {
            return replacePlaceholderWithActualBrandValues(uc.campaignDescription, brand)
        }
        if (other && useCases[0] === other) {
            return other
        }
    }

    if (isOnlyMarketingPresent(useCases)) {
        return replacePlaceholderWithActualBrandValues(
            campaign2ndStepRemoteValues.MULTIPLE_MARKETING_campaign_description,
            brand,
            useCases
        )
    }

    if (useCases.length && !isMarketingUsecasePresent(useCases)) {
        return replacePlaceholderWithActualBrandValues(
            campaign2ndStepRemoteValues.NO_MARKETING_AND_OTHER_campaign_description,
            brand,
            useCases
        )
    }

    // mixed transactional and marketing
    if (useCases.length) {
        return replacePlaceholderWithActualBrandValues(
            campaign2ndStepRemoteValues.MIXED_TRANSACTIONAL_AND_MARKETING_campaign_description,
            brand,
            useCases
        )
    }

    // default to customerCare
    return replacePlaceholderWithActualBrandValues(
        (useCasesOptions.find((x) => x.id === 'SCHEDULE_APPOINTMENTS') || {}).campaignDescription,
        brand
    )
}

export default generateCampaignDescription
